import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
    const storedUser = localStorage.getItem("usertpi");
    const uid = storedUser ? JSON.parse(storedUser)?.usertpi : null;

    return uid ? <Outlet /> : <Navigate to="/sim" replace />;
};

export default ProtectedRoute;